import React from 'react';

import AppModal from 'components/modal/appModal';
import { SimpleModalId } from 'constants/modalId';
import { makeGuardedModal } from 'components/guardedModal/makeGuardedModal';
import { PortalsClearCacheFormProps } from './PortalsClearCacheForm.types';

export const PortalsClearCacheForm = ({ id, onSubmit, data: { domain } }: PortalsClearCacheFormProps) => {
  const handleSubmit = () => {
    const portalDomain = domain.endsWith('/') ? domain.substr(0, domain.length - 1) : domain;
    onSubmit(portalDomain);
  };

  return (
    <AppModal
      id={id}
      title="Clear clip site cache"
      hideOpenButton
      submitButtonLabel="Yes"
      closeButtonLabel="No"
      submitAction={handleSubmit}
    >
      <p>
        Are you sure you want to clear cache of
        <strong>
          <a href={`${process.env.REACT_APP_PORTALS_PROTOCOL}://${domain}`} target="_blank" rel="noopener noreferrer">
            &nbsp;{domain}&nbsp;
          </a>
        </strong>
        clip site?
      </p>
    </AppModal>
  );
};

export const PortalsClearCacheModal = makeGuardedModal(SimpleModalId.ClearPortalCacheModal, PortalsClearCacheForm);
